import type { Transition } from "framer-motion";

type Bezier = [number, number, number, number];

/** Shared timing for the quick-look card. Springs are critically damped so a morph can reverse mid-flight. */
export const motionTokens = {
  blur: {
    subtle: 2,
    soft: 6,
  },
  duration: {
    instant: 0.12,
    fast: 0.2,
    standard: 0.32,
    considered: 0.45,
    exit: 0.22,
  },
  ease: {
    standard: [0.32, 0.72, 0, 1] as Bezier,
    enter: [0.16, 1, 0.3, 1] as Bezier,
  },
  spring: {
    smooth: { type: "spring", bounce: 0, visualDuration: 0.4 } satisfies Transition,
    snappy: { type: "spring", bounce: 0.18, visualDuration: 0.25 } satisfies Transition,
  },
  stagger: {
    word: 0.035,
  },
};
